<template>
    <b-form>
      <b-form-group
        label="Event Title"
        description="Event Title"
        :label-cols="3"
        :horizontal="true"
      >
        <b-form-input type="text" placeholder="Title" v-model="event.title" ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Events Content"
        description="Content"
        :label-cols="3"
        :horizontal="true"
      >
        <editor :content="event.content" />
      </b-form-group>
      <b-form-group
        label="Event Venue"
        description="Event Venue"
        :label-cols="3"
        :horizontal="true"
      >
        <b-form-input type="text" placeholder="Venue" v-model="event.venue" ></b-form-input>
      </b-form-group>
      <b-form-group label="Publish Date"
                    description="News Publish Date"
                    :label-cols="3"
                    :horizontal="true"
      >
        <datepicker input-class="form-control" v-model="event.publishedAt"></datepicker>
      </b-form-group>
      <b-form-group label="Event Date"
                    description="Event Date"
                    :label-cols="3"
                    :horizontal="true"
      >
        <datepicker input-class="form-control" v-model="event.eventAt"></datepicker>
      </b-form-group>
      <b-form-group
        label="Event Map Lat & Lng"
        description="Event Map"
        :label-cols="3"
        :horizontal="true"
      >
        <b-checkbox :checked="event.mapLatLng === null ? false : true" >
          Has Map?
        </b-checkbox>
        <b-form-input type="text" placeholder="Lat" v-if="event.mapLatLng" v-model="event.mapLatLng.lat" ></b-form-input>
        <b-form-input type="text" placeholder="Lng" v-if="event.mapLatLng" v-model="event.mapLatLng.lng" ></b-form-input>
      </b-form-group>
    </b-form>
</template>

<script>
    import {Event} from "../../models/Event";
    import Editor from "../base/Editor";
    import Datepicker from "vuejs-datepicker/src/components/Datepicker";

    export default {
        name: "EventForm",
        components: {
            Editor,
            Datepicker,
        },
        props: {
            event: {
              type: Object,
              default: new Event(),
            }
        }
    }
</script>

<style scoped>

</style>
